import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { InstituicaoSentenca } from '../../../types/sentencaArbitral.types';
interface SecaoEncerramentoSentencaProps {
  instituicao: InstituicaoSentenca;
  codigoAutenticacao: string;
}
export function SecaoEncerramentoSentenca(t0) {
  const $ = _c(35);
  const {
    instituicao,
    codigoAutenticacao
  } = t0;
  let t1;
  if ($[0] !== instituicao.logoUrl || $[1] !== instituicao.orgao) {
    t1 = <Image alt={instituicao.orgao} className="h-[22px] w-fit object-contain" height={22} src={instituicao.logoUrl} width={93} />;
    $[0] = instituicao.logoUrl;
    $[1] = instituicao.orgao;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== instituicao.contatoEmail || $[4] !== instituicao.contatoSite) {
    t2 = <span className="text-brand-600 text-[13.5px]">{instituicao.contatoEmail} | {instituicao.contatoSite}</span>;
    $[3] = instituicao.contatoEmail;
    $[4] = instituicao.contatoSite;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex flex-col gap-[14px]">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-[11px] text-neutral-900/50">Assinado digitalmente por:</span>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = `Assinatura de ${instituicao.orgao}`;
  let t6;
  if ($[10] !== instituicao.assinaturaImagemUrl || $[11] !== t5) {
    t6 = <Image alt={t5} className="ml-auto h-[52px] w-auto object-contain" height={52} src={instituicao.assinaturaImagemUrl} width={160} />;
    $[10] = instituicao.assinaturaImagemUrl;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== instituicao.orgao) {
    t8 = <strong className="text-brand-600">{instituicao.orgao}</strong>;
    $[14] = instituicao.orgao;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== instituicao.assinaturaCargo || $[17] !== t8) {
    t9 = <div className="mt-[2px] border-t border-solid border-neutral-900 pt-[6px] text-[12.5px] text-neutral-700">{instituicao.assinaturaCargo}{t7}{t8}</div>;
    $[16] = instituicao.assinaturaCargo;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="text-right">{t4}{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t3) {
    t11 = <div className="bg-brand-600/10 flex flex-wrap items-end justify-between gap-6 px-[43px] py-[18px]">{t3}{t10}</div>;
    $[22] = t10;
    $[23] = t3;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== instituicao.rodapeLegal) {
    t12 = <span className="text-[10.5px] text-neutral-400">{instituicao.rodapeLegal}</span>;
    $[25] = instituicao.rodapeLegal;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== codigoAutenticacao) {
    t13 = <span className="text-[9px] tracking-[1px] text-neutral-400 uppercase">Cód. de Autenticação · <span className="font-semibold text-neutral-500">{codigoAutenticacao}</span></span>;
    $[27] = codigoAutenticacao;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <div className="flex flex-wrap items-center justify-between gap-2 border-t border-solid border-neutral-200 px-[43px] py-2.5">{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t14) {
    t15 = <>{t11}{t14}</>;
    $[32] = t11;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}